// extracted by mini-css-extract-plugin
export default {"container":"AnswerSubmit_container__QkTsb","button":"AnswerSubmit_button__-XOfB","icon":"AnswerSubmit_icon__oE3SA"};